import { render, staticRenderFns } from "./ImportGoLiveModal.vue?vue&type=template&id=15b34777&scoped=true"
import script from "./ImportGoLiveModal.vue?vue&type=script&lang=js"
export * from "./ImportGoLiveModal.vue?vue&type=script&lang=js"
import style0 from "./ImportGoLiveModal.vue?vue&type=style&index=0&id=15b34777&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b34777",
  null
  
)

export default component.exports